import { useAuthStore } from '@/stores/authStore';

export default function UserNameDisplay() {
  const { user } = useAuthStore();
  const userFullName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`;

  return (
    <div className="w-full h-[54px] flex justify-center items-center rounded-[23px] border border-gray-300 p-4 mb-1">
      <span className="text-base font-medium text-black">{userFullName}</span>
    </div>
  );
}
